export interface ClassWalletAmount {
  walletExpenseAmount: number | null;
  expenseDescription?: string | null;
}

export interface ClassWalletTotals {
  cwFundsPaid: number | null;
  cwFundsSpent: number | null;
  cwFundsRemaining: number | null;
}

export const EMPTY_CLASS_WALLET_TOTALS: ClassWalletTotals = Object.freeze({
  cwFundsPaid: null,
  cwFundsSpent: null,
  cwFundsRemaining: null
});

function isEsaDeposit(description: string | null | undefined): boolean {
  const text = (description ?? '').toLowerCase();
  return text.includes('esa') && text.includes('deposit');
}

export function computeClassWalletTotals(transactions: readonly ClassWalletAmount[] | null): ClassWalletTotals {
  if (!transactions?.length) {
    return EMPTY_CLASS_WALLET_TOTALS;
  }

  let paid = 0;
  let spent = 0;
  let balance = 0;
  for (const transaction of transactions) {
    const amount = transaction.walletExpenseAmount ?? 0;
    balance += amount;
    if (amount < 0) {
      spent -= amount;
    }
    if (isEsaDeposit(transaction.expenseDescription)) {
      paid += amount;
    }
  }

  return { cwFundsPaid: paid, cwFundsSpent: spent, cwFundsRemaining: balance };
}
